import { LevelEditorGoalPicker } from './LevelEditorGoalPicker';

/* eslint-disable quote-props */
/* eslint-disable no-restricted-globals */

/**
 * Class for editing a levels goals
 */
export class LevelEditorGoalPanel extends Phaser.Group {
  /**
   * constructor
   * @param {number} x
   * @param {number} y
   * @param {Object} lvlData
   */
  constructor(x, y, lvlData) {
    super(game);

    this.x = G.l(x); this.y = G.l(y);
    this._state = game.state.getCurrentState();

    this._lvlData = lvlData;
    this._goals = [];

    this.signals = {
      onGoalChanged: new Phaser.Signal(),
    };

    this._makeGoalLabel();
    this._makeAddGoalButton();
    this._makeSubtractGoalButton();
    this._makeChangeGoalTypeButton();
    this._makePointsTargetField();

    this._loadLvlGoals();
  }

  /**
   * make goal label field
   */
  _makeGoalLabel() {
    this.add(new G.Text(0, 0, 'GOAL:', 'editor', [0, 0.5], 400));
  }

  /**
   * make the add goal button
   */
  _makeAddGoalButton() {
    const plusBtn = new G.Button(160, 0, 'plus_ico', () => {
      if (this._lvlData.goal[0] === 'points') return;
      if (this._goals.length >= 4) return;
      this._makeGoalItem(this._goals.length);
      this.signals.onGoalChanged.dispatch();
    });
    plusBtn.IMMEDIATE = true;
    this.add(plusBtn);
  }

  /**
   * make the remove goal button
   */
  _makeSubtractGoalButton() {
    const minusBtn = new G.Button(200, 0, 'minus_ico', () => {
      if (this._lvlData.goal[0] === 'points') return;
      if (this._goals.length === 1) return;
      this._removeGoal();
      this.signals.onGoalChanged.dispatch();
    });
    minusBtn.IMMEDIATE = true;
    this.add(minusBtn);
  }

  /**
   * make button to alternate goal type between candies / points
   */
  _makeChangeGoalTypeButton() {
    const changeGoalTypeBtn = new G.Button(270, 0, 'minus_ico', () => {
      if (this._lvlData.goal[0] === 'points') {
        this._lvlData.goal = ['collect', [['1', 5], ['2', 5]]];
      } else {
        this._lvlData.goal = ['points', 5000];
      }
      this._loadLvlGoals();
      this.signals.onGoalChanged.dispatch();
    });
    changeGoalTypeBtn.IMMEDIATE = true;
    changeGoalTypeBtn.angle = 90;
    this.add(changeGoalTypeBtn);
  }

  /**
   * make field to display / edit target goal points
   */
  _makePointsTargetField() {
    const pointsTarget = this._lvlData.goal[0] === 'points' ? this._lvlData.goal[1] : 1000;
    this._pointTxt = new G.Text(50, 50, pointsTarget, 'editor-aquamarine');
    this.add(this._pointTxt);
    this._pointTxt.anchor.setTo(0, 0.5);
    this._pointTxt.inputEnabled = true;
    this._pointTxt.input.useHandCursor = true;
    this._pointTxt.events.onInputDown.add(() => {
      G.Utils.debugPrompt('Enter points target').then(((answer) => {
        if (isNaN(parseInt(answer))) return;
        this._lvlData.goal[1] = parseInt(answer);
        this._pointTxt.setText(parseInt(answer));
        this.signals.onGoalChanged.dispatch();
      }));
    });
  }

  /**
   * update function
   */
  update() {
    if (this._lvlData.goal[0] === 'points') return;
    for (let i = 0; i < this._goals.length; i++) {
      this._updateGoal(this._goals[i]);
    }
  }

  /**
   * load levels goals from the level data
   */
  _loadLvlGoals() {
    this._goals.forEach((g) => { g.destroy(); });
    this._goals = [];
    if (this._lvlData.goal[0] === 'points') {
      this._pointTxt.visible = true;
      this._pointTxt.setText(this._lvlData.goal[1]);
    } else {
      this._pointTxt.visible = false;
      this._lvlData.goal[1].forEach((elem, index) => {
        this._makeGoalItem(index, elem[0], elem[1]);
      });
    }
  }

  /**
   * make / add a new goal item for the level
   * @param {number} index
   * @param {name} name
   * @param {number} nr
   */
  _makeGoalItem(index, name, nr) {
    // create a goal item
    const goalItem = game.make.group();
    goalItem.goalIndex = index;
    goalItem.x = G.l(50); goalItem.y = G.l(50 + (50 * index));
    goalItem.allGoals = Object.keys(G.json['configs/gameplayGoals']);
    goalItem.goalName = name || goalItem.allGoals[0];
    goalItem.goalNr = nr || 5;

    // create goal image and set event to launch the goal picker
    goalItem.img = G.makeImage(0, 0, null, 0.5, goalItem);
    goalItem.img.scale.setTo(0.6);
    goalItem.img.refreshGraphics = () => {
      G.changeTexture(goalItem.img, G.json['configs/gameplayGoals'][goalItem.goalName].sprite);
    };
    goalItem.img.refreshGraphics();
    goalItem.img.inputEnabled = true;
    goalItem.img.input.useHandCursor = true;
    goalItem.img.events.onInputDown.add(() => {
      const goalPicker = new LevelEditorGoalPicker();
      goalPicker.onGoalPicked.add((goalName) => {
        goalItem.goalName = goalName;
        this._lvlData.goal[1][goalItem.goalIndex][0] = goalItem.goalName;
        goalItem.img.refreshGraphics();
        this.signals.onGoalChanged.dispatch();
      });
    });

    // goal alert. not sure if this is used??
    goalItem.alert = new G.Text(250, 0, 'ALERT', 'editor');
    goalItem.alert.anchor.setTo(0, 0.5);
    goalItem.alert.tint = 0xff0000;
    goalItem.alert.visible = false;
    goalItem.add(goalItem.alert);

    // set goal # display and debug prompt
    goalItem.nr = new G.Text(50, 0, goalItem.goalNr.toString(), 'editor-aquamarine');
    goalItem.add(goalItem.nr);
    goalItem.nr.anchor.setTo(0, 0.5);
    goalItem.nr.inputEnabled = true;
    goalItem.nr.input.useHandCursor = true;
    goalItem.nr.events.onInputDown.add(() => {
      G.Utils.debugPrompt('Enter moves number').then(((answer) => {
        if (isNaN(parseInt(answer))) return;
        this._lvlData.goal[1][goalItem.goalIndex][1] = parseInt(answer);
        goalItem.goalNr = answer;
        goalItem.nr.setText(goalItem.goalNr.toString());
        this.signals.onGoalChanged.dispatch();
      }));
    });
    this.add(goalItem);
    this._goals.push(goalItem);

    // add goal to level data
    if (index >= this._lvlData.goal[1].length) {
      this._lvlData.goal[1].push([goalItem.goalName, goalItem.goalNr]);
    }
  }

  /**
   * remove last level goal
   */
  _removeGoal() {
    const goalToRemove = this._goals.pop();
    goalToRemove.destroy();
    this._lvlData.goal[1].pop();
  }

  /**
   * update goal state / status
   * @param {Object} goalItem
   */
  _updateGoal(goalItem) {
    const countConfig = this._countGoal(goalItem.goalName);
    const target = goalItem.goalNr;
    let txt = goalItem.goalNr.toString();
    let fill = '#a8dbc6';
    if (!countConfig.ignore) {
      txt = `${txt} (${countConfig.amount})`;
      if (countConfig.amount < target) {
        if (countConfig.okAnyway) fill = '#ffa500';
        else fill = '#ff0000';
      }
    }
    goalItem.nr.setText(txt);
    goalItem.nr.fill = fill;
  }

  /**
   * count instances of a goalType in the current layout
   * @param {string} goalName
   */
  _countGoal(goalName) {
    const state = game.state.getCurrentState();
    const { board } = state;

    // goal counting functions
    const ignore = () => ({ ignore: true });
    const generateLayerCheck = (layer) => () => ({ amount: layer.getAllTokens().length });
    const generateCandyCheck = (symbol, optDropName, optExportString) => () => {
      const result = { amount: 0, okAnyway: false };
      const { drops } = this._lvlData;
      const candyDropRate = optDropName ? G.Utils.defined(drops[optDropName], 0) : 0;
      let boardAmount;
      let dropZonesAmount;
      if (optExportString) {
        boardAmount = state.board.boardCandies.countExportStringOccurrence(symbol);
        dropZonesAmount = state.dropZones.countExportStringOccurrence(symbol);
      } else {
        boardAmount = state.board.boardCandies.countEditorSymbolOccurrence(symbol);
        dropZonesAmount = state.dropZones.countEditorSymbolOccurrence(symbol);
      }
      result.amount = boardAmount + dropZonesAmount;
      if (candyDropRate > 0) result.okAnyway = true;
      return result;
    };

    const goals = {
      '1': ignore,
      '2': ignore,
      '3': ignore,
      '4': ignore,
      '5': ignore,
      '6': ignore,
      'concrete': generateLayerCheck(board.boardCage),
      'dirt': generateLayerCheck(board.boardDirt),
      'chain': generateCandyCheck('W', 'chain'),
      'ice': generateLayerCheck(board.boardIce),
      'infection': generateCandyCheck('infection', 'infection'),
      'goalCandy': generateCandyCheck('goalCandy', 'goalCandy'),
      'blocker': ignore,
      'dirtS': generateLayerCheck(board.boardDirtS),
      'lc|0': generateCandyCheck('lc'),
      'jam': generateLayerCheck(board.boardJam),
      'spiral': ignore,
      'vertical': ignore,
      'horizontal': ignore,
      'cross': ignore,
      'superSpiral': ignore,
      'dbl_cross': ignore,
      'vertVertCross': ignore,
      'horHorCross': ignore,
      'vertHorCross': ignore,
      'bx': generateCandyCheck('bx'),
      'bx:1': generateCandyCheck('bx|1', null, true),
      'bx:2': generateCandyCheck('bx|2', null, true),
      'bx:3': generateCandyCheck('bx|3', null, true),
      'bx:4': generateCandyCheck('bx|4', null, true),
      'bx:5': generateCandyCheck('bx|5', null, true),
      'bx:6': generateCandyCheck('bx|6', null, true),
    };

    if (goals[goalName]) return goals[goalName]();
    return ignore();
  }
}
